'use client';

import clsx from 'clsx';

import './StepContainer.scss';

const StepContainer = ({
  children,
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={clsx('step-container', className)} {...rest}>
      {children}
    </div>
  );
};

export default StepContainer;
